interface Props {
  /** What's actually happening — default is deliberately generic. The
      scoring flow passes its own copy; auth gates say "Signing you in…"
      (the old hardcoded scoring text flashing on sign-in read as a
      phantom report build). */
  message?: string;
  /** Optional second line, e.g. expected duration. */
  detail?: string;
}

export function LoadingState({ message = "Loading…", detail }: Props) {
  return (
    <div className="loading-state" role="status" aria-live="polite">
      <div className="spinner" />
      <p>{message}</p>
      {detail && <p className="loading-detail">{detail}</p>}
    </div>
  );
}
